import { Component, EventEmitter, Input, Output } from '@angular/core'

@Component({
  selector: 'dmmp-programmes-results',
  templateUrl: './programmes-results.component.html',
})
export class ProgrammesResultsComponent {
  @Input() module: any
  @Input() identifier: string
  @Output() anchorCustom = new EventEmitter()
  @Output() redirectPage = new EventEmitter()
  @Output() deleteFilterEmitter = new EventEmitter()
  @Output() clearFiltersEmitter = new EventEmitter()
  @Input() programmesResult: any
  @Input() searchResult: any
  @Input() currentFilters: any
  @Input() loaderState = false
  @Input() clearAllLabel = 'Borrar todo'

  deleteFilter(filterEle) {
    this.currentFilters.options.splice(
      this.currentFilters.options.indexOf(filterEle),
      1
    )
    this.deleteFilterEmitter.emit(this.currentFilters)
  }

  clearFilters() {
    this.clearFiltersEmitter.emit()
  }
}
